import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  HostListener
} from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { OrderService } from 'src/app/services/order.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { DataTransferService } from '../../cat-edit/data-transfer.service';
import { ESignService } from 'src/app/services/e-sign.service';
import { MessageService } from 'primeng/api';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentService } from '../../../models/paymentService';
import { UserManagementService } from 'src/app/services/user-management.service';
import { ImageGeneratorService } from 'src/app/services/image-generator.service';
import { buildOrderFileName } from 'src/app/shared-components/order-file-name.util';
import { fitSignatureBoxInPage } from 'src/app/shared-components/signature-box.util';
import { getStandardSignatureRect } from 'src/app/shared-components/signature-position.util';
interface Coordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}
interface SignatureCoordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

interface SignatureConfig {
  method: 'AADHAAR' | 'DSC';
  sign_position: string;
  page: string;
}

interface PositionDetails {
  [key: string]: Coordinates[];
}
@Component({
    selector: 'app-e-sign-form',
    templateUrl: './e-sign-form.component.html',
    styleUrls: ['./e-sign-form.component.scss'],
    standalone: false
})
export class ESignFormComponent implements OnInit {
  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  @ViewChild('paymentScreen') paymentScreen: TemplateRef<any>;

  selectedState: any;
  showUploadFileDetails: boolean = true;
  showEsignDetails: boolean = false;
  showConfirmation: boolean = false;
  order_payment: boolean = false;
  //-------------------------Step Active --------------------------------------//
  active_Upload: boolean = false;
  active_eSign: boolean = false;
  active_confirm: boolean = false;
  //-------------------Import & export variables ----------------------------//
  uploadFileData: any;
  reviewOrderData: any;
  esignData: any;
  orderConfirmationData: any = { service: 'E-Stamp' };
  electronicPrice: number;
  dscPrice: number;
  aadhaarPrice: number;
  selectedBranch: any;
  totalPages: number;
  pageHeight: number[];
  order_reviewer: boolean;
  userRole: string;
  pageWidth: number[];
  paymentOption: any;
  paymentDetailsData: any = [];
  totalAmount: number = 1;
  paymentData: PaymentService;
  paymentDetails: {
    payeeName: string;
    payeeEmail: string;
    payeeMobileNumber: string;
    payNow: string;
    paymentMethod: string;
  };
  signDetails: any;
  electronicSigner: any = [];
  aadhaarSigner: any = [];
  dscSigner: any = [];
  paymentOrderData: any;
  isSignerEnable: boolean = false;
  userData: any = [];
  branches: any = [];
  userId: any;
  account_id: any;
  branch_id: any;

  //------------------------------------------------------------------------------//
  constructor(
    private storageService: StorageService,
    private eSignService: ESignService,
    private orderService: OrderService,
    private dataTransferService: DataTransferService,
    private catUploadService: CatUploadService,
    private confirmationService: ConfirmationService,
    private modalService: NgbModal,
    private primeng: PrimeNG,
    private router: Router,
    private userDashboardService: UserDashboardService,
    private messageService: MessageService,
    private cookieService: CookieService,
    private userManagementService: UserManagementService,
    private imageGeneratorService: ImageGeneratorService
  ) {
    this.storageService.setContractType(false);

    this.paymentData = new PaymentService();
    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;
    this.account_id = this.storageService.getAccountId() || null;

    this.userRole = this.storageService.getRole() || null;
    this.userId = this.storageService.getUserID() || null;
    this.electronicPrice = this.paymentData.esignElectronicPrice;
    this.dscPrice = this.paymentData.esignDSCPrice;
    this.aadhaarPrice = this.paymentData.esignAadhaarPrice;
    this.storageService.getSignerValue.subscribe((res) => {
      this.isSignerEnable = res;
    });
  }

  ngOnInit(): void {
    this.primeng.ripple.set(true);
    this.editUserDetails(this.userId);
    this.storageService.setDocumentToBeStamped(false);
    this.esignData = {
      toBeEsigned: true,
      totalPages: this.uploadFileData?.totalPages || 0
    };
  }
  //-------------------Import & export Data from parent to child and vice-versa ----------------------------//
  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
    // Show confirmation dialog for unsaved data on page refresh
    event.preventDefault();
    event.returnValue = false;
  }

  changeState(data: any) {
    this.uploadFileData = data;
  }

  editUserDetails(id: any) {
    this.userManagementService.getUsersDetailsById(id).subscribe((res: any) => {
      this.userData = res['content'][0];

      if (this.userData.id === Number(id)) {
        this.branches = this.userData.branches.map((branch) => branch);
      }
    });
  }

  onUploadFileDataChange(data: any): void {
    this.uploadFileData = data;

    this.totalPages = this.uploadFileData.totalPages;
    this.pageHeight = this.uploadFileData.pageHeight;
    this.pageWidth = this.uploadFileData.pageWidth;
    console.log(' this.pageHeight ', this.pageHeight);
    console.log(' this.pageWidth ', this.pageWidth);

    const value = this.uploadFileData.page;
    this.catUploadService.uploadDocumentsDetails = this.uploadFileData;
    this.gotToCatEditScreen(value);
    this.esignData.pdfData = this.dataTransferService.getPdfData();
  }

  async onesignDataChange(data: any): Promise<void> {
    this.order_payment = data.paymentbySigner;
    this.paymentDetails = {
      payeeName: data.payeeName,
      payeeEmail: data.payeeEmail,
      payeeMobileNumber: data.payeeMobileNumber,
      payNow: data.payNowOrLater,
      paymentMethod: data.paymentMethod
    };

    if (!data.placeOrder) {
      this.gotToCatEditScreen('upload');
      return;
    }

    this.esignData.branch_id = this.branches[0];
    this.esignData = data;
    this.esignData.document = this.uploadFileData.base64Doc || this.uploadFileData.file; 
    // Process each signatory's details
    data.signatory_details.forEach((sign) => {
      if (!sign.position_details) {
        console.error('Missing position details for signature');
        return;
      }
      console.log('Processing signatory:', sign);
      if (sign.sign_position === 'DRAG_DROP') {
        // For drag & drop, only validate and ensure coordinates are within bounds
        Object.keys(sign.position_details).forEach((page) => {
          const pageIndex = parseInt(page) - 1;
          if (pageIndex >= 0 && pageIndex < this.totalPages) {
            const pageHeight = this.pageHeight[pageIndex];
            const pageWidth = this.pageWidth[pageIndex];

            // Keep each box on the page by moving it, not by trimming its
            // edges, so a box near an edge keeps the common signature size.
            sign.position_details[page] = sign.position_details[page].map(
              (coord) =>
                fitSignatureBoxInPage(
                  coord.x1,
                  coord.y1,
                  coord.x2 - coord.x1,
                  coord.y2 - coord.y1,
                  pageWidth,
                  pageHeight
                )
            );
          }
        });
        sign.pages = Object.keys(sign.position_details).join(',');
      }
      // else if (sign.sign_position === 'DEFAULT') {
      //   const allSigns = data.signatory_details;

      //   const maxPerRow = 5;
      //   const paddingY = 10;

      //   let pagesArray: string[] = [];

      //   if (typeof sign.pages === 'string') {
      //     const pages = sign.pages.trim().toUpperCase();

      //     pagesArray =
      //       pages === 'ALL'
      //         ? Array.from({ length: this.totalPages }, (_, i) =>
      //             (i + 1).toString()
      //           )
      //         : pages.split(',').map((p) => p.trim());
      //   }

      //   const positionDetails: any = {};

      //   pagesArray.forEach((page) => {

      //     // STEP 1: filter only relevant signatories for this page
      //     const signsForPage = allSigns.filter((s) => {
      //       if (!s.pages) return false;

      //       if (typeof s.pages === 'string') {
      //         const pages = s.pages.trim().toUpperCase();

      //         if (pages === 'ALL') return true;

      //         return pages.split(',').map(p => p.trim()).includes(page);
      //       }

      //       return false;
      //     });

      //     // STEP 2: index within THIS page
      //     const index = signsForPage.findIndex((s) => s === sign);
      //     if (index === -1) return;

      //     const pageIndex = parseInt(page) - 1;
      //     const pageHeight = this.pageHeight[pageIndex];
      //     const pageWidth = this.pageWidth[pageIndex];

      //     // STEP 3: calculate box size for EACH sign (method aware)
      //     const getBoxSize = (s: any) => {
      //       if (s.method === 'AADHAAR' || s.method === 'DSC') {
      //         const isSmallPage = pageWidth < 500;

      //         const width = Math.round(
      //           isSmallPage
      //             ? Math.min(100, pageWidth * 0.4)
      //             : Math.min(160, pageWidth * 0.2)
      //         );

      //         const height = Math.round(
      //           isSmallPage
      //             ? Math.min(30, pageHeight * 0.15)
      //             : Math.min(50, pageHeight * 0.1)
      //         );

      //         return { width, height };
      //       }

      //       // ELECTRONIC
      //       return {
      //         width: Math.round(pageWidth * 0.18),
      //         height: 50
      //       };
      //     };

      //     // STEP 4: compute row-wise heights (IMPORTANT FIX)
      //     const rows: any[] = [];

      //     signsForPage.forEach((s, i) => {
      //       const rowIndex = Math.floor(i / maxPerRow);

      //       if (!rows[rowIndex]) {
      //         rows[rowIndex] = [];
      //       }

      //       rows[rowIndex].push(getBoxSize(s).height);
      //     });

      //     const rowHeights = rows.map(row =>
      //       Math.max(...row) + paddingY
      //     );

      //     const totalRows = rowHeights.length;

      //     // STEP 5: block positioning (bottom aligned)
      //     const blockHeight = rowHeights.reduce((a, b) => a + b, 0);
      //     const bottomMargin = 20;

      //     const startY = pageHeight - bottomMargin - blockHeight;

      //     //  STEP 6: find row & col
      //     const row = Math.floor(index / maxPerRow);
      //     const col = index % maxPerRow;

      //     //  STEP 7: compute Y using dynamic row heights
      //     let yOffset = 0;
      //     for (let r = 0; r < row; r++) {
      //       yOffset += rowHeights[r];
      //     }

      //     const { width: boxWidth, height: boxHeight } = getBoxSize(sign);

      //     const y1 = startY + yOffset;
      //     const y2 = y1 + boxHeight;

      //     //  STEP 8: horizontal centering
      //     const total = signsForPage.length;
      //     const totalCols = Math.min(total, maxPerRow);

      //     const gapX = Math.round(pageWidth * 0.02);

      //     const totalWidth =
      //       totalCols * boxWidth + (totalCols - 1) * gapX;

      //     const startX = Math.round((pageWidth - totalWidth) / 2);

      //     const x1 = startX + col * (boxWidth + gapX);
      //     const x2 = x1 + boxWidth;

      //     let finalY1 = y1;
      //     let finalY2 = y2;

      //     if (sign.method === 'AADHAAR' || sign.method === 'DSC') {
      //       const pageHeight = this.pageHeight[pageIndex];

      //       // FLIP Y AXIS
      //       finalY1 = pageHeight - (y2 - 14);
      //       finalY2 = pageHeight - (y1 - 14);
      //     }
      //     positionDetails[page] = [{
      //       x1,
      //       x2,
      //       y1: finalY1,
      //       y2: finalY2
      //     }];
      //   });

      //   sign.position_details = positionDetails;
      // }
      else {
        let pagesArray: string[] = [];

        if (typeof sign.pages === 'string') {
          const pages = sign.pages.trim().toUpperCase();
          pagesArray =
            pages === 'ALL'
              ? Array.from({ length: this.totalPages }, (_, i) =>
                  (i + 1).toString()
                )
              : pages.split(',').map((page) => page.trim());
        } else if (typeof sign.pages === 'number') {
          pagesArray = [sign.pages.toString()];
        }

        pagesArray.forEach((page) => {
          const pageIndex = parseInt(page) - 1;
          if (pageIndex >= 0 && pageIndex < this.totalPages) {
            const pageHeight = Math.round(this.pageHeight[pageIndex]);
            const pageWidth = Math.round(this.pageWidth[pageIndex]);

            // e-sign-details already worked out this signature's rect (for this
            // page, or for "ALL"); use it as is. Otherwise fall back to the same
            // shared calculation, so every flow places a position identically.
            const preparedRect =
              sign.position_details?.[page]?.[0] ?? sign.position_details?.['ALL']?.[0];
            if (preparedRect && Number.isFinite(Number(preparedRect.y2))) {
              sign.position_details[page] = [{ ...preparedRect }];
            } else if (
              sign.method === 'ELECTRONIC' ||
              sign.method === 'AADHAAR' ||
              sign.method === 'DSC'
            ) {
              sign.position_details[page] = [
                getStandardSignatureRect(sign.method, sign.sign_position, pageWidth, pageHeight)
              ];
            }
          }
        });
      }

      // Clean up ALL key if it exists
      if (sign.position_details['ALL']) {
        delete sign.position_details['ALL'];
      }
    });

    // Prepare and send order
    const branch_id = this.storageService.getBranchId() || null;
    let documentBase64 = this.uploadFileData?.base64Doc ?? this.uploadFileData?.file ?? null;
    if (documentBase64) {
      documentBase64 = await this.imageGeneratorService.mergeAuthorisedFramesIntoPdf(
        documentBase64,
        data.signatory_details || [],
      );
    }
    const orderObj = {
      is_bulk: false,
      document: documentBase64,
      file_name: buildOrderFileName(
        this.uploadFileData.referenceNumber,
        this.uploadFileData.fileName ?? null,
      ),
      order_details: [
        {
          account_id: this.account_id,
          branch_id: branch_id,
          referance_id: this.uploadFileData.referenceNumber,
          esigns: {
            party_users: data.signatory_details,
            witness_users: data.witness_users
          }
        }
      ]
    };

    if (this.order_reviewer) {
      // this.confirmOrder(orderObj);
      this.onApproveMethod(orderObj);
    } else if (this.order_payment && this.isSignerEnable) {
      this.getPayment(orderObj);
    } else {
      this.placeOrderData(orderObj);
    }
  }


  reviewOrderDataChange(data: any) {
    this.closeModel();
    if (data.path === 'order') {
      this.placeOrderData(data.details);
    }
  }

  // confirmOrder(Obj) {
  //   const reviewData = { serviceType: 'E-sign', details: Obj };
  //   this.reviewOrderData = reviewData;
  //   this.confirmationService.confirm({
  //     message: 'Do you want to get your request to be reviewed by Checker?',
  //     header: 'Confirmation',
  //     icon: 'pi pi-exclamation-circle',
  //     accept: () => {
  //       this.placeOrderData(Obj);
  //     },
  //     acceptLabel: 'No , Proceed to Place Order',
  //     acceptIcon: 'pi pi',
  //     reject: (type) => {
  //       switch (type)
  //       {
  //         case ConfirmEventType.REJECT:
  //           this.onApproveMethod();
  //           break;
  //         case ConfirmEventType.CANCEL:
  //           break;
  //       }
  //     },
  //     rejectLabel: 'Yes',
  //     rejectIcon: 'pi pi'
  //   });
  // }

  placeOrderData(Obj) {
    if (this.order_payment && this.isSignerEnable) {
      this.getPayment(Obj);
    } else {
      this.eSignService.sendEsignDetails(Obj).subscribe((res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Order Placed',
          detail: 'Order placed successfully. Please check the provided email'
        });
        setTimeout(() => {
          this.router.navigate([
            'doqfy/e-sign/order-confirmation',
            res.content.order_id
          ]);
        }, 1000);
      });
    }
  }

  onApproveMethod(Obj) {
    const reviewData = { serviceType: 'E-sign', details: Obj };
    this.reviewOrderData = reviewData;
    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  closeModel() {
    this.modalService.dismissAll();
  }

  //-------------------------------------------------------------------------------------------------//

  //-------- to Display the required component depending on the click of the stepper------------//

  gotToCatEditScreen(value: string): void {
    this.showUploadFileDetails = value === 'upload';
    this.showEsignDetails = value === 'esign';
    this.showConfirmation = value === 'confirmation';
    this.setActiveTab(value);
  }

  //------------Change the color of the stepper on completion ------------------------------//

  setActiveTab(value: string) {
    if (value === 'upload') {
      this.active_Upload = false;
      this.active_eSign = false;
      this.active_confirm = false;
    } else {
      this.active_Upload = true;
      this.active_eSign = value !== 'upload' && value !== 'esign';
      this.active_confirm = value === 'confirmation';
    }
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  onOrderConfirmationChange(data: any): void {
    this.orderConfirmationData = data;
  }

  //------------------------------------Payment Option --------------------------------//

  getPayment(Obj) {
    this.paymentOrderData = {
      orderDetails: Obj,
      payment: this.paymentDetails,
      service_type: 'E-Sign'
    };
    this.modalService
      .open(this.paymentScreen, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  paymentOrderDataChange(event) {
    if (event.status === 200) {
      this.messageService.add({
        severity: 'success',
        summary: 'Order Placed successfully!',
        detail: event.message
      });
      this.closeModel();
    }
  }
  //-------------------------------------------------------------------------------------//
}
